module.exports = __webpack_public_path__ + "static/media/eek10.23eff12b.JPG";